import boat from '../images/snaps/boat.jpg'
import bondiRoad from '../images/snaps/bondiRoad.jpg'
import bwBondi from '../images/snaps/bwBondi.jpg'
import bwRock from '../images/snaps/bwRock.jpg';
import sunRise2 from '../images/snaps/sunRise2.jpg'
import couple from '../images/snaps/couple.jpg'
import darling from '../images/snaps/darling.jpg'
import kangaroo from '../images/snaps/kangaroo.jpg'
import kidBuddha from '../images/snaps/kidBuddha.jpg'
import laPerouse from '../images/snaps/laPerouse.jpg'
import leafs from '../images/snaps/leafs.jpg'
import leafSun from '../images/snaps/leafSun.jpg'
import moon from '../images/snaps/moon.jpg'
import opera from '../images/snaps/opera.jpg'
import sunRise from '../images/snaps/sunRise.jpg'
import vivid from '../images/snaps/vivid.jpg'
import html from '../images/tech/html.jpg'
import js from '../images/tech/js.png'
import java from '../images/tech/java.webp'
import css from '../images/tech/css3.jpg'
import react from '../images/tech/react.webp'
import next from '../images/tech/next.jpg'
import node from '../images/tech/node.png'
import mongo from '../images/tech/mongo.PNG'
import postgres from '../images/tech/post.PNG'
import bootstrap from '../images/tech/bootstrap.jpg'
import tailwind from '../images/tech/tailwind.jpg'




const datas =[boat, bondiRoad, bwBondi, bwRock, laPerouse, couple, darling, kangaroo, 

                    , leafSun,opera, sunRise, vivid]

export default datas;

export const techs= [ html, js, java, css, react, next, bootstrap, tailwind, node, mongo, postgres ]
export const revTechs =[js, postgres, mongo, node, tailwind, bootstrap, next, react, css, java, html]